/**
 * Nexsus Plus - Customer Reviews Enhancements & Star Rating Filter
 * Multi-select star rating filter across ALL 423+ reviews.
 */
(function() {
  'use strict';

  // 1. Ensure WiseReviews loads ALL available reviews (up to 500)
  if (window.wiseReviewsWidgetSettings && window.wiseReviewsWidgetSettings.product_reviews) {
    window.wiseReviewsWidgetSettings.product_reviews.number_of_reviews_per_page_desktop = "500";
    window.wiseReviewsWidgetSettings.product_reviews.number_of_reviews_per_page_mobile = "500";
  }

  // Intercept window.fetch to ensure itemsPerPage=500 for WiseReviews API
  if (!window.__wiseFetchIntercepted) {
    window.__wiseFetchIntercepted = true;
    const origFetch = window.fetch;
    window.fetch = function(url, options) {
      if (typeof url === 'string' && url.includes('wise-reviews.codexapps.co/api/proxy/reviews')) {
        let newUrl = url.replace(/itemsPerPage=\d+/, 'itemsPerPage=500');
        if (!newUrl.includes('itemsPerPage=')) {
          newUrl += (newUrl.includes('?') ? '&' : '?') + 'itemsPerPage=500';
        }
        return origFetch.call(this, newUrl, options).then(async (res) => {
          try {
            const clone = res.clone();
            const data = await clone.json();
            if (data && data.data) {
              window.__wiseAllReviews = data.data;
              window.__wiseMeta = data.meta;
              buildReviewLookup(data.data);
              updateCountsFromData(data.data);
              // Re-run filter once data is ready
              applyFilterAndPagination();
            }
          } catch(e) {}
          return res;
        });
      }
      return origFetch.apply(this, arguments);
    };
  }

  // Active filter state (numbers: 1, 2, 3, 4, 5). Empty set = all reviews
  const activeRatings = new Set();
  const PAGE_BATCH = 16;
  let currentVisibleLimit = PAGE_BATCH;
  let observer = null;
  let exactCounts = { 1: 13, 2: 2, 3: 7, 4: 21, 5: 380, total: 423 };
  const reviewLookup = [];

  function buildReviewLookup(reviews) {
    reviewLookup.length = 0;
    reviews.forEach(r => {
      reviewLookup.push({
        id: r.id,
        author: (r.reviewer_name || '').toLowerCase().trim(),
        snippet: (r.body || '').substring(0, 35).toLowerCase().trim(),
        rating: parseInt(r.rating, 10)
      });
    });
  }

  function init() {
    ensureCustomerReviewsTabOnly();
    checkAndInjectFilterBar();
    attachSummaryBarListeners();
    applyFilterAndPagination();

    // Fetch review data proactively to ensure instant lookup & counts
    fetchProductReviewData();

    // Set up MutationObserver to detect DOM changes from WiseReviews
    if (!observer) {
      observer = new MutationObserver(debounce(() => {
        ensureCustomerReviewsTabOnly();
        checkAndInjectFilterBar();
        attachSummaryBarListeners();
        applyFilterAndPagination();
      }, 60));

      const target = document.body;
      if (target) {
        observer.observe(target, { childList: true, subtree: true });
      }
    }
  }

  function debounce(fn, ms) {
    let timer;
    return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), ms);
    };
  }

  // Proactively fetch all review data from proxy
  async function fetchProductReviewData() {
    try {
      const prodId = window.wiseReviewsProduct?.id || 
                     document.querySelector('wise-product-reviews')?.getAttribute('data-product-id') ||
                     '15752135803206';
      const shop = window.Shopify?.shop || '199da1-60.myshopify.com';
      const url = `https://wise-reviews.codexapps.co/api/proxy/reviews?shop=${shop}&product_id=${prodId}&type=product_reviews&itemsPerPage=500`;
      const res = await fetch(url);
      const data = await res.json();
      if (data && data.data) {
        window.__wiseAllReviews = data.data;
        buildReviewLookup(data.data);
        updateCountsFromData(data.data);
        applyFilterAndPagination();
      }
    } catch(e) {}
  }

  function updateCountsFromData(reviews) {
    const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, total: reviews.length };
    reviews.forEach(r => {
      const star = parseInt(r.rating, 10);
      if (counts[star] !== undefined) {
        counts[star]++;
      }
    });
    exactCounts = counts;
    updateFilterUiCounts();
  }

  function updateFilterUiCounts() {
    const bar = document.getElementById('nexsus-reviews-filter-bar');
    if (!bar) return;

    // Update pill counts
    bar.querySelectorAll('.nrf-chip').forEach(chip => {
      const val = chip.dataset.rating;
      const countSpan = chip.querySelector('.nrf-chip-count');
      if (countSpan) {
        if (val === 'all') {
          countSpan.innerText = `(${exactCounts.total || 423})`;
        } else {
          const num = parseInt(val, 10);
          countSpan.innerText = `(${exactCounts[num] !== undefined ? exactCounts[num] : 0})`;
        }
      }
    });

    // Update dropdown counts
    bar.querySelectorAll('.nrf-dropdown-item').forEach(item => {
      const input = item.querySelector('input');
      const countSpan = item.querySelector('.nrf-dropdown-count');
      if (input && countSpan) {
        const num = parseInt(input.value, 10);
        countSpan.innerText = `(${exactCounts[num] !== undefined ? exactCounts[num] : 0})`;
      }
    });
  }

  // 2. Ensure only "Customer Reviews" tab is visible and active
  function ensureCustomerReviewsTabOnly() {
    const tabsList = document.querySelector('.wise-product-reviews ul.wise-flex.wise-flex-nowrap');
    if (tabsList) {
      const items = tabsList.querySelectorAll('li');
      if (items.length > 1) {
        items[1].style.display = 'none';
        items.forEach(li => {
          if (li.innerText && li.innerText.toLowerCase().includes('all reviews')) {
            li.style.display = 'none';
          }
        });
      }
      const custBtn = items[0]?.querySelector('button');
      if (custBtn && custBtn.className.includes('wise-opacity-50')) {
        custBtn.click();
      }
    }
  }

  // 3. Extract rating (1 to 5) accurately from a review card
  function getCardRating(card) {
    if (card.dataset.wiseRating) {
      return parseInt(card.dataset.wiseRating, 10);
    }

    // Method 1: react-rating icon active span check (spans with width: 100%)
    const ratingContainer = card.querySelector('.wise-inline-flex.wise-items-center') ||
                            card.querySelector('span[style*="inline-block"]');
    if (ratingContainer) {
      // In react-rating, each star has a parent span. Inside it, activeIcon is in a span with style.width.
      // A filled star has style="... width: 100%;". An empty star has style="... width: 0%;".
      const spans = ratingContainer.querySelectorAll('span');
      let filledCount = 0;
      spans.forEach(s => {
        const w = s.style.width;
        if (w && (w === '100%' || parseFloat(w) >= 50)) {
          // Verify it has an SVG child or activeIcon
          if (s.querySelector('svg')) {
            filledCount++;
          }
        }
      });
      if (filledCount >= 1 && filledCount <= 5) {
        card.dataset.wiseRating = filledCount;
        return filledCount;
      }
    }

    // Method 2: Match review text & author against our lookup catalog
    const cardText = (card.innerText || '').toLowerCase();
    if (reviewLookup.length > 0) {
      for (let i = 0; i < reviewLookup.length; i++) {
        const item = reviewLookup[i];
        if (item.author && cardText.includes(item.author)) {
          if (!item.snippet || cardText.includes(item.snippet)) {
            card.dataset.wiseRating = item.rating;
            return item.rating;
          }
        }
      }
    }

    // Fallback: Default to 5
    card.dataset.wiseRating = 5;
    return 5;
  }

  // 4. Inject Filter Bar above reviews grid
  function checkAndInjectFilterBar() {
    const reviewsContainer = document.querySelector('.wise-product-reviews');
    if (!reviewsContainer) return;

    const columnsContainer = reviewsContainer.querySelector('.wise-flex.wise-justify-center.wise-my-4') ||
                             reviewsContainer.querySelector('[class*="wr-id-review-column"]')?.parentElement;
    if (!columnsContainer) return;

    let filterBar = document.getElementById('nexsus-reviews-filter-bar');
    if (!filterBar) {
      filterBar = document.createElement('div');
      filterBar.id = 'nexsus-reviews-filter-bar';
      filterBar.className = 'nexsus-reviews-filter-bar';
      filterBar.innerHTML = `
        <div class="nrf-top-row">
          <div class="nrf-title-group">
            <span class="nrf-label">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
              </svg>
              Filter Reviews
            </span>
            <span class="nrf-count-badge" id="nrf-count-badge">Showing all (${exactCounts.total || 423})</span>
          </div>
          <div class="nrf-actions-group">
            <div class="nrf-dropdown-wrapper">
              <button type="button" class="nrf-dropdown-toggle" id="nrf-dropdown-toggle" aria-expanded="false">
                <span>Filter by Star</span>
                <svg class="nrf-chevron" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
                </svg>
              </button>
              <div class="nrf-dropdown-menu" id="nrf-dropdown-menu">
                <div class="nrf-dropdown-header">
                  <span>Multi-Select Stars</span>
                  <button type="button" class="nrf-clear-btn" id="nrf-clear-dropdown">Clear All</button>
                </div>
                <label class="nrf-dropdown-item">
                  <div class="nrf-dropdown-left">
                    <input type="checkbox" value="5" class="nrf-rating-checkbox">
                    <span class="nrf-stars">★★★★★</span>
                    <span class="nrf-item-label">5 Stars</span>
                  </div>
                  <span class="nrf-dropdown-count">(${exactCounts[5] || 380})</span>
                </label>
                <label class="nrf-dropdown-item">
                  <div class="nrf-dropdown-left">
                    <input type="checkbox" value="4" class="nrf-rating-checkbox">
                    <span class="nrf-stars">★★★★☆</span>
                    <span class="nrf-item-label">4 Stars</span>
                  </div>
                  <span class="nrf-dropdown-count">(${exactCounts[4] || 21})</span>
                </label>
                <label class="nrf-dropdown-item">
                  <div class="nrf-dropdown-left">
                    <input type="checkbox" value="3" class="nrf-rating-checkbox">
                    <span class="nrf-stars">★★★☆☆</span>
                    <span class="nrf-item-label">3 Stars</span>
                  </div>
                  <span class="nrf-dropdown-count">(${exactCounts[3] || 7})</span>
                </label>
                <label class="nrf-dropdown-item">
                  <div class="nrf-dropdown-left">
                    <input type="checkbox" value="2" class="nrf-rating-checkbox">
                    <span class="nrf-stars">★★☆☆☆</span>
                    <span class="nrf-item-label">2 Stars</span>
                  </div>
                  <span class="nrf-dropdown-count">(${exactCounts[2] || 2})</span>
                </label>
                <label class="nrf-dropdown-item">
                  <div class="nrf-dropdown-left">
                    <input type="checkbox" value="1" class="nrf-rating-checkbox">
                    <span class="nrf-stars">★☆☆☆☆</span>
                    <span class="nrf-item-label">1 Star</span>
                  </div>
                  <span class="nrf-dropdown-count">(${exactCounts[1] || 13})</span>
                </label>
              </div>
            </div>
            <button type="button" class="nrf-reset-btn" id="nrf-reset-btn" style="display:none;">
              <span>✕</span> Clear Filters
            </button>
          </div>
        </div>
        <div class="nrf-chips-group">
          <button type="button" class="nrf-chip active" data-rating="all">
            All Reviews <span class="nrf-chip-count">(${exactCounts.total || 423})</span>
          </button>
          <button type="button" class="nrf-chip" data-rating="5">
            <span class="nrf-chip-star">★</span> 5 Star <span class="nrf-chip-count">(${exactCounts[5] || 380})</span>
          </button>
          <button type="button" class="nrf-chip" data-rating="4">
            <span class="nrf-chip-star">★</span> 4 Star <span class="nrf-chip-count">(${exactCounts[4] || 21})</span>
          </button>
          <button type="button" class="nrf-chip" data-rating="3">
            <span class="nrf-chip-star">★</span> 3 Star <span class="nrf-chip-count">(${exactCounts[3] || 7})</span>
          </button>
          <button type="button" class="nrf-chip" data-rating="2">
            <span class="nrf-chip-star">★</span> 2 Star <span class="nrf-chip-count">(${exactCounts[2] || 2})</span>
          </button>
          <button type="button" class="nrf-chip" data-rating="1">
            <span class="nrf-chip-star">★</span> 1 Star <span class="nrf-chip-count">(${exactCounts[1] || 13})</span>
          </button>
        </div>
      `;

      columnsContainer.parentNode.insertBefore(filterBar, columnsContainer);
      attachFilterBarEvents(filterBar);
      updateFilterUiCounts();
    }
  }

  // 5. Attach Filter Bar Events
  function attachFilterBarEvents(bar) {
    bar.querySelectorAll('.nrf-chip').forEach(chip => {
      chip.addEventListener('click', () => {
        const ratingVal = chip.dataset.rating;
        currentVisibleLimit = PAGE_BATCH;
        if (ratingVal === 'all') {
          activeRatings.clear();
        } else {
          const num = parseInt(ratingVal, 10);
          if (activeRatings.has(num)) {
            activeRatings.delete(num);
          } else {
            activeRatings.add(num);
          }
        }
        syncUiAndFilter();
      });
    });

    const toggleBtn = bar.querySelector('#nrf-dropdown-toggle');
    const menu = bar.querySelector('#nrf-dropdown-menu');
    if (toggleBtn && menu) {
      toggleBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = menu.classList.contains('show');
        menu.classList.toggle('show', !isOpen);
        toggleBtn.classList.toggle('open', !isOpen);
        toggleBtn.setAttribute('aria-expanded', !isOpen);
      });

      document.addEventListener('click', (e) => {
        if (!bar.contains(e.target)) {
          menu.classList.remove('show');
          toggleBtn.classList.remove('open');
          toggleBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    bar.querySelectorAll('.nrf-rating-checkbox').forEach(cb => {
      cb.addEventListener('change', () => {
        currentVisibleLimit = PAGE_BATCH;
        const num = parseInt(cb.value, 10);
        if (cb.checked) {
          activeRatings.add(num);
        } else {
          activeRatings.delete(num);
        }
        syncUiAndFilter();
      });
    });

    bar.querySelector('#nrf-clear-dropdown')?.addEventListener('click', () => {
      activeRatings.clear();
      currentVisibleLimit = PAGE_BATCH;
      syncUiAndFilter();
    });

    bar.querySelector('#nrf-reset-btn')?.addEventListener('click', () => {
      activeRatings.clear();
      currentVisibleLimit = PAGE_BATCH;
      syncUiAndFilter();
    });
  }

  // 6. Clickable Rating Bars in Summary
  function attachSummaryBarListeners() {
    const summaryContainer = document.querySelector('.wise-product-reviews');
    if (!summaryContainer) return;

    const breakdownRows = summaryContainer.querySelectorAll('.wise-flex.wise-items-center.wise-my-1');
    breakdownRows.forEach(row => {
      if (row.dataset.nrfAttached) return;
      row.dataset.nrfAttached = 'true';

      const text = row.innerText || '';
      let starNum = null;
      if (text.includes('5')) starNum = 5;
      else if (text.includes('4')) starNum = 4;
      else if (text.includes('3')) starNum = 3;
      else if (text.includes('2')) starNum = 2;
      else if (text.includes('1')) starNum = 1;

      if (starNum) {
        row.dataset.starRating = starNum;
        row.title = `Click to filter by ${starNum} star reviews (${exactCounts[starNum] !== undefined ? exactCounts[starNum] : ''})`;
        row.addEventListener('click', () => {
          currentVisibleLimit = PAGE_BATCH;
          if (activeRatings.has(starNum)) {
            activeRatings.delete(starNum);
          } else {
            activeRatings.add(starNum);
          }
          syncUiAndFilter();
          const fb = document.getElementById('nexsus-reviews-filter-bar');
          if (fb) {
            fb.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    });
  }

  // 7. Sync UI Elements
  function syncUiAndFilter() {
    const bar = document.getElementById('nexsus-reviews-filter-bar');
    if (!bar) return;

    const isAll = activeRatings.size === 0;

    // Update chips active state
    bar.querySelectorAll('.nrf-chip').forEach(chip => {
      const val = chip.dataset.rating;
      if (val === 'all') {
        chip.classList.toggle('active', isAll);
      } else {
        const num = parseInt(val, 10);
        chip.classList.toggle('active', activeRatings.has(num));
      }
    });

    // Update dropdown checkboxes
    bar.querySelectorAll('.nrf-rating-checkbox').forEach(cb => {
      const num = parseInt(cb.value, 10);
      cb.checked = activeRatings.has(num);
    });

    // Reset button visibility
    const resetBtn = bar.querySelector('#nrf-reset-btn');
    if (resetBtn) {
      resetBtn.style.display = isAll ? 'none' : 'inline-flex';
    }

    // Highlight summary rows
    document.querySelectorAll('.wise-product-reviews .wise-flex.wise-items-center.wise-my-1').forEach(row => {
      const star = parseInt(row.dataset.starRating, 10);
      row.classList.toggle('nrf-bar-active', activeRatings.has(star));
    });

    applyFilterAndPagination();
  }

  // 8. Core Filter & Smart Pagination Logic
  function applyFilterAndPagination() {
    const reviewsContainer = document.querySelector('.wise-product-reviews');
    if (!reviewsContainer) return;

    const columns = reviewsContainer.querySelectorAll('[class*="wr-id-review-column"]');
    const allCards = [];
    columns.forEach(col => {
      col.childNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('wise-rounded-lg')) {
          allCards.push(node);
        }
      });
    });

    if (allCards.length === 0) return;

    const isAll = activeRatings.size === 0;
    const matchingCards = [];

    // Tag and filter
    allCards.forEach(card => {
      const rating = getCardRating(card);
      let matches = false;

      if (isAll) {
        matches = true;
      } else if (rating && activeRatings.has(rating)) {
        matches = true;
      }

      if (matches) {
        matchingCards.push(card);
      } else {
        card.classList.add('nrf-hidden-card');
      }
    });

    // If matching count is small (e.g. 1-star has 13 reviews), show all matching instantly
    const limit = matchingCards.length <= 24 ? matchingCards.length : currentVisibleLimit;

    // Display visible batch
    matchingCards.forEach((card, idx) => {
      if (idx < limit) {
        card.classList.remove('nrf-hidden-card');
      } else {
        card.classList.add('nrf-hidden-card');
      }
    });

    // Update Count Badge
    const badge = document.getElementById('nrf-count-badge');
    if (badge) {
      if (isAll) {
        badge.classList.remove('filtering');
        badge.innerText = `Showing all (${allCards.length} reviews)`;
      } else {
        badge.classList.add('filtering');
        const sorted = Array.from(activeRatings).sort().reverse();
        badge.innerText = `Showing ${matchingCards.length} of ${allCards.length} (${sorted.map(s => s + '★').join(', ')})`;
      }
    }

    // Manage Pagination "Load More" Button
    managePaginationButton(reviewsContainer, matchingCards.length, limit);

    // Empty state
    handleEmptyState(reviewsContainer, matchingCards.length, allCards.length, isAll);
  }

  // 9. Custom "Load More Reviews" Button
  function managePaginationButton(container, totalMatching, currentlyVisible) {
    let pagWrapper = document.getElementById('nrf-pagination-wrapper');
    const columnsContainer = container.querySelector('.wise-flex.wise-justify-center.wise-my-4') ||
                             container.querySelector('[class*="wr-id-review-column"]')?.parentElement;

    if (currentlyVisible < totalMatching) {
      if (!pagWrapper) {
        pagWrapper = document.createElement('div');
        pagWrapper.id = 'nrf-pagination-wrapper';
        pagWrapper.className = 'nrf-pagination-wrapper';
        pagWrapper.innerHTML = `
          <button type="button" class="nrf-load-more-btn" id="nrf-load-more-btn">
            Load More Reviews
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
          <span class="nrf-pagination-info" id="nrf-pagination-info"></span>
        `;
        if (columnsContainer) {
          columnsContainer.parentNode.insertBefore(pagWrapper, columnsContainer.nextSibling);
        }
        pagWrapper.querySelector('#nrf-load-more-btn')?.addEventListener('click', () => {
          currentVisibleLimit += PAGE_BATCH;
          applyFilterAndPagination();
        });
      }
      pagWrapper.style.display = 'flex';
      const info = pagWrapper.querySelector('#nrf-pagination-info');
      if (info) {
        info.innerText = `Showing ${currentlyVisible} of ${totalMatching} reviews`;
      }
    } else {
      if (pagWrapper) {
        pagWrapper.style.display = 'none';
      }
    }
  }

  // 10. Empty state
  function handleEmptyState(container, visibleCount, totalCards, isAll) {
    let emptyBox = document.getElementById('nrf-empty-state');
    const columnsContainer = container.querySelector('.wise-flex.wise-justify-center.wise-my-4') ||
                             container.querySelector('[class*="wr-id-review-column"]')?.parentElement;

    if (!isAll && visibleCount === 0 && totalCards > 0) {
      if (!emptyBox) {
        emptyBox = document.createElement('div');
        emptyBox.id = 'nrf-empty-state';
        emptyBox.className = 'nrf-empty-state';
        emptyBox.innerHTML = `
          <div class="nrf-empty-icon">⭐</div>
          <div class="nrf-empty-title">No reviews match the selected star ratings</div>
          <div class="nrf-empty-text">Try selecting other star ratings or view all reviews.</div>
          <button type="button" class="nrf-empty-reset-btn" id="nrf-empty-reset-btn">Show All Reviews</button>
        `;
        if (columnsContainer) {
          columnsContainer.parentNode.insertBefore(emptyBox, columnsContainer.nextSibling);
        }
        emptyBox.querySelector('#nrf-empty-reset-btn')?.addEventListener('click', () => {
          activeRatings.clear();
          currentVisibleLimit = PAGE_BATCH;
          syncUiAndFilter();
        });
      }
      emptyBox.style.display = 'block';
    } else {
      if (emptyBox) {
        emptyBox.style.display = 'none';
      }
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
